import type { KpiMode } from '../../types/consolidatedBusiness';

const OPTIONS: { value: KpiMode; label: string }[] = [
    { value: 'net', label: 'Net Sales' },
    { value: 'quantity', label: 'Quantity' },
    { value: 'grossprofit', label: 'Gross Profit' },
];

interface Props {
    value: KpiMode;
    onChange: (m: KpiMode) => void;
}

export function KpiModeToggle({ value, onChange }: Props) {
    return (
        <div className="inline-flex rounded-md border border-gray-300 bg-white p-0.5" role="group" aria-label="Figures shown">
            {OPTIONS.map(opt => (
                <button
                    key={opt.value}
                    type="button"
                    onClick={() => onChange(opt.value)}
                    aria-pressed={value === opt.value}
                    className={`h-8 rounded px-3 text-xs font-medium transition-colors motion-reduce:transition-none ${
                        value === opt.value
                            ? 'bg-blue-600 text-white'
                            : 'text-gray-600 hover:bg-gray-100'
                    }`}
                >
                    {opt.label}
                </button>
            ))}
        </div>
    );
}
